import { URL_REGEX_PATTERN } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const validateValue = {
  price: {
    min: 0,
    max: 999999999999,
  },
  pos: {
    min: 1,
  },
  categories: {
    min: 1,
  },
  images: {
    min: 1,
  },
  quantity: {
    min: 1,
  },
  limit_min: {
    min: 1,
  },
}

const validationSchema = Yup.object().shape(
  {
    name: Yup.string()
      .max(255)
      .trim()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>),
    categories: Yup.array()
      .transform((value) => (null === value ? [] : value))
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_CATEGORY')}</Translation>)
      .min(
        validateValue.categories.min,
        <Translation>{(t) => t('VALIDATE.MIN_CATEGORY', { number: validateValue.categories.min })}</Translation>
      ),
    expired_date: Yup.date()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_EXPIRED')}</Translation>)
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(new Date(), <Translation>{(t) => t('VALIDATE.VALIDATE_EXPIRED')}</Translation>),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PRICE')}</Translation>)
      .integer(<Translation>{(t) => t('VALIDATE.INTEGER_PRICE')}</Translation>)
      .min(
        validateValue.price.min,
        <Translation>{(t) => t('VALIDATE.VALID_MIN_PRICE', { number: validateValue.price.min })}</Translation>
      )
      .max(
        validateValue.price.max,
        <Translation>{(t) => t('VALIDATE.VALID_MAX_PRICE', { number: validateValue.price.max })}</Translation>
      ),
    quantity: Yup.number()
      .integer(<Translation>{(t) => t('VALIDATE.INTEGER_QUANTITY')}</Translation>)
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(
        validateValue.quantity.min,
        <Translation>{(t) => t('VALIDATE.VALID_MIN_QUANTITY', { number: validateValue.quantity.min })}</Translation>
      )
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_QUANTITY')}</Translation>),
    limit_max: Yup.number()
      .integer(<Translation>{(t) => t('VALIDATE.LIMIT_VALID_MAX_INT')}</Translation>)
      .transform((value) => (isNaN(value) ? undefined : value))
      .when('limit_min', (limit_min, schema) =>
        schema.min(limit_min, <Translation>{(t) => t('VALIDATE.VALID_MAX_VOUCHER')}</Translation>)
      )
      .when('quantity', (quantity, schema) =>
        schema.max(quantity, <Translation>{(t) => t('VALIDATE.VALID_MAX_VOUCHER_WITH_QUANTITY')}</Translation>)
      ),
    images: Yup.array()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_SLIDER')}</Translation>)
      .min(
        validateValue.images.min,
        <Translation>{(t) => t('VALIDATE.VALIDATE_SLIDER', { number: validateValue.images.min })}</Translation>
      ),
    pos: Yup.array()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_POS')}</Translation>)
      .min(
        validateValue.pos.min,
        <Translation>{(t) => t('VALIDATE.VALID_POS', { number: validateValue.pos.min })}</Translation>
      ),
    info_link: Yup.string()
      .nullable()
      .notRequired()
      .when('info_link', {
        is: (value) => value?.length,
        then: (rule) =>
          rule.matches(URL_REGEX_PATTERN, {
            message: <Translation>{(t) => t('VALIDATE.HOME_PAGE_LINK')}</Translation>,
          }),
      }),
    limit_min: Yup.number()
      .integer(<Translation>{(t) => t('VALIDATE.LIMIT_VALID_MIN_INT')}</Translation>)
      .nullable()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(
        validateValue.limit_min.min,
        <Translation>{(t) => t('VALIDATE.VALID_MIN_LIMIT', { number: validateValue.limit_min.min })}</Translation>
      )
      .when('quantity', (quantity, schema) =>
        schema.max(quantity, <Translation>{(t) => t('VALIDATE.VALID_MIN_VOUCHER_WITH_QUANTITY')}</Translation>)
      ),
  },
  [['info_link', 'info_link']]
)

export default validationSchema
